import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatePick = (props) => {
  const [date, setDate] = useState(new Date());

  const handleOnConfirmData = (date) => {
    setDate(date);
    if (props.handleSetDate) {
      props.handleSetDate(date);
    }
  };

  const handelOnCancel = () => {
    if (props.handelOnCancel) {
      props.handelOnCancel();
    }
  };

  return (
    <div className={`overlay ${props.open ? "visible" : ""}`}>
      <div className="date-view">
        <DatePicker
          selected={date}
          onChange={handleOnConfirmData}
          dateFormat="yyyy/MM/dd"
          showPopperArrow={false}
        />
        <button onClick={handelOnCancel} className="deleteBtn" style={{color: '#fff'}}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default DatePick;
